import { render, staticRenderFns } from "./DescriptionItem.vue?vue&type=template&id=a8c7a870&scoped=true"
import script from "./DescriptionItem.vue?vue&type=script&lang=ts"
export * from "./DescriptionItem.vue?vue&type=script&lang=ts"
import style0 from "./DescriptionItem.vue?vue&type=style&index=0&id=a8c7a870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c7a870",
  null
  
)

export default component.exports